
import React, { useContext, Children, useEffect, useRef, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from 'react-router-dom'
import Button from '../formfields/Button'
import Spinner from '../ui-elements/Spinner'
import { useLocation } from '../context/location/LocationContext'
import LocationMapVector from '../ui-elements/LocationMapVector'



type Props = {
  setQuestionAnswer: any
  defaultValue: null | string | string[]
  questionId: string
}

function QuestionLocation({
  setQuestionAnswer,
  defaultValue,
  questionId
}: Props) {

  const {

  } = useContext(GlobalContext)

  const [locationFromGps, setLocationFromGps] = useState<Coordinates | null>(null)
  const [locationFromUser, setLocationFromUser] = useState<Coordinates | null>(null)
  const [locationAsString, setLocationAsString] = useState<string>(``)
  const [locationManuallyEntered, setLocationManuallyEntered] = useState<string>(``)


  useEffect(() => {
    if (locationFromGps && !locationFromUser) {
      setQuestionAnswer({
        locationFromGps,
        locationAsString
      })
    } else if (locationFromGps && locationFromUser) {
      setQuestionAnswer({
        locationFromGps,
        locationFromUser,
        locationAsString
      })
    } else if (locationManuallyEntered) {
      setQuestionAnswer({
        locationManuallyEntered
      })
    }
  }, [locationFromGps, locationFromUser, locationAsString, locationManuallyEntered])


  return <LocationMapVector
    locationFromGps={locationFromGps}
    locationFromUser={locationFromUser}
    locationAsString={locationAsString}
    locationManuallyEntered={locationManuallyEntered}
    setLocationFromGps={setLocationFromGps}
    setLocationFromUser={setLocationFromUser}
    setLocationAsString={setLocationAsString}
    setLocationManuallyEntered={setLocationManuallyEntered}

  />

}
export default QuestionLocation